export default __webpack_public_path__ + "static/media/instagram.5ed60826.svg";